import React from "react"
import { MDCTextField } from '@material/textfield';
import { MDCRipple } from '@material/ripple';
import axios from 'axios'
import sha256 from "sha256"

async function login() {
  var login = document.querySelector("#loginInput").value
  var password = document.querySelector("#passwordInput").value
  var res = await axios.get(`https://nakrutkatop.com:443/api/auth/login?login=${login}&passwordHash=${sha256(password)}`, { withCredentials: true, credentials: 'same-origin', crossdomain: true })
  if (res.data.ok) window.location.reload();
  else document.querySelector("#errorText").innerHTML = "Неверный логин или пароль, попробуйте снова"
}

async function register() {
  var login = document.querySelector("#loginInput").value
  console.log(document.querySelector("#loginInput").value)
  var password = document.querySelector("#passwordInput").value
  try {
    var ref = (document.cookie + ";").split("ref=")[1].split(";")[0]
  }
  catch {
    var ref = 0
  }
  var res = await axios.get(`https://nakrutkatop.com:443/api/auth/register?login=${login}&passwordHash=${sha256(password)}&ref=${ref}`, { withCredentials: true })
  if (res.data.ok) window.location.reload();
  else document.querySelector("#errorText").innerHTML = "Логин занят, попробуйте снова"
}

class LoginPage extends React.Component {

  componentDidMount() {

    const loginField = new MDCTextField(document.querySelector('#loginField'))
    const passwordField = new MDCTextField(document.querySelector('#passwordField'))

    const regButton = new MDCRipple(document.querySelector('#regButton'));
    const loginButton = new MDCRipple(document.querySelector('#loginButton'));

    document.cookie = "ref=" + window.location.search.replace('?', '').split("r=")[1]

    window.telegramLogin = async (user)=>{
      try {
        var ref = (document.cookie + ";").split("ref=")[1].split(";")[0]
      }
      catch {
        var ref = 0
      }
      var res = await axios.post(`https://nakrutkatop.com:443/api/auth/tgLogin`, {user, ref}, { withCredentials: true })
      if (res.data.ok) window.location.reload();
      else document.querySelector("#errorText").innerHTML = "Ошибка авторизации"
    }

    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?14";
    script.async = true;
    script.setAttribute('data-telegram-login', "Boostify_bot");
    script.setAttribute('data-size', "large");
    script.setAttribute('data-userpic', "false");
    script.setAttribute('data-onauth', "telegramLogin(user)");
    script.setAttribute('data-request-access', "write");
    document.querySelector("#loginBox").appendChild(script)
  }

  render(props) {
    console.log(props)
    return <div className="loginPage" style={{ opacity: "0", visibility: "hidden", transition: ".55s opacity, .55s visibility" }}>
      <div className="loginForm">
        <h3 style={{ marginTop: "25px" }}>Войдите</h3>
        чтобы воспользоваться нашими услугами
        <div className="lpFields" id="loginBox">

          <label class="mdc-text-field mdc-text-field--outlined" id="loginField" style={{ width: "45%", display: "inline-flex", marginRight: "5px" }}>
            <input type="text" class="mdc-text-field__input" aria-labelledby="my-label-id" id="loginInput" />
            <span class="mdc-notched-outline">
              <span class="mdc-notched-outline__leading"></span>
              <span class="mdc-notched-outline__notch">
                <span class="mdc-floating-label" id="my-label-id">Логин</span>
              </span>
              <span class="mdc-notched-outline__trailing"></span>
            </span>
          </label>


          <button class="mdc-button mdc-button--raised" id="regButton" onClick={register} style={{ width: "45%", display: "inline-flex", marginLeft: "5px", height: "56px", marginBottom: "0.5rem", top: "+1px" }}>
            <div class="mdc-button__ripple"></div>
            <i class="material-icons mdc-button__icon" aria-hidden="true">person_add</i>
            <span class="mdc-button__label">Регистрация</span>
          </button>

          <label class="mdc-text-field mdc-text-field--outlined" id="passwordField" style={{ width: "45%", display: "inline-flex", marginRight: "5px" }}>
            <input type="password" class="mdc-text-field__input" aria-labelledby="my-label-id1" id="passwordInput" />
            <span class="mdc-notched-outline">
              <span class="mdc-notched-outline__leading"></span>
              <span class="mdc-notched-outline__notch">
                <span class="mdc-floating-label" id="my-label-id1">Пароль</span>
              </span>
              <span class="mdc-notched-outline__trailing"></span>
            </span>
          </label>

          <button class="mdc-button mdc-button--raised" id="loginButton" onClick={login} style={{ width: "45%", display: "inline-flex", marginLeft: "5px", height: "56px", marginBottom: "0.5rem", top: "+2px" }}>
            <div class="mdc-button__ripple"></div>
            <i class="material-icons mdc-button__icon" aria-hidden="true">login</i>
            <span class="mdc-button__label">Вход</span>
          </button>

          <p id="errorText"></p>

        </div>
      </div>
    </div>
  }
}

export default LoginPage